import { Box, Typography } from "@mui/material";
import React from "react";
import ServiceCard from "../common/ServiceCard";

function ProductsSection() {
  const productLists = [
    {
      title: "Chili Powder & Paprika",
      info: "Finely ground, vibrant red chili powder and paprika – essential for adding color, heat, and depth to your dishes. Pure, natural, and free from additives. Perfect for curries, marinades, and traditional Indian cooking.",
      imgVid: "/assets/new/7_1.png",
      imgLeft: false,
      url: "#chili-powder-paprika",
    },
    {
      title: "Whole Spices & Blends",
      info: "Premium whole spices including cinnamon, fennel seeds, peppercorns, star anise, and turmeric. Fresh, aromatic, and essential for authentic flavors in your kitchen. Sourced from trusted farms for purity and rich taste.",
      imgVid: "/assets/new/31.jpg",
      imgLeft: true,
      url: "#whole-spices",
    },
    {
      title: "Spice Blends & Mixes",
      info: "Premium spice blends and ground mixes for every recipe. Rich, aromatic, and carefully sourced. Ideal for curries, masalas, and everyday cooking – bringing authentic flavors to your kitchen.",
      imgVid: "/assets/new/mega2_spices.jpg",
      imgLeft: false,
      url: "#spice-blends",
    },
    {
      title: "Bay Leaves",
      info: "Aromatic, dried bay leaves (tej patta) – a staple in Indian kitchens for tempering, biryanis, curries, and rice dishes. Natural, fragrant, and essential for authentic flavor. Handpicked for freshness and quality.",
      imgVid: "/assets/new/bay_leaf_1.jpg",
      imgLeft: true,
      url: "#bay-leaves",
    },
    {
      title: "Shahi Jeera & Cumin Seeds",
      info: "Pure, aromatic shahi jeera (black cumin) and cumin seeds, essential for authentic Indian cooking. Whole and unrefined for maximum flavor and freshness. Perfect for tempering, curries, and traditional recipes.",
      imgVid: "/assets/new/shahi_jeera_2.jpg",
      imgLeft: false,
      url: "#shahi-jeera-cumin",
    },
    {
      title: "Premium Spices",
      info: "100% Natural & Unrefined – Farm-fresh premium spices including turmeric, bay leaf, star anise, shahi jeera and more. Sourced directly from cooperative farmers, ensuring authenticity and superior quality for your kitchen.",
      imgVid: "/assets/new/EC76674907_Banner2.jpg",
      imgLeft: true,
      url: "#premium-spices",
    },
  ];

  return (
    <section className="layoutMargin" id="Products">
      <Box sx={{ px: { lg: "0px", xs: "40px" } }}>
        <Typography
          variant="h2"
          className="caveatFont"
          sx={{ color: "#778A24", mt: 2, textAlign: "center" }}
        >
          🛒 Our Products
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "center", mb: 4 }}>
          Discover the finest groceries, fresh organic items, and everyday essentials – all available at Gujco Mall.
        </Typography>

        {productLists.map((product, index) => (
          <ServiceCard
            key={index}
            title={product.title}
            info={product.info}
            imgVid={product.imgVid}
            imgLeft={product.imgLeft}
            url={product.url}
          />
        ))}
      </Box>
    </section>
  );
}

export default ProductsSection;
